export const RESERVATION_STATUS = {
  ACTIVE: 'Active',
  IN_STORE: 'In Store',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  AUTOEXIT: 'Left Store(Auto)'
}
const moment = require('moment-timezone')

export function determineStatusValue(reservation, store) {
  if (reservation.iscancelled == 1) {
    return RESERVATION_STATUS.CANCELLED
  }
  if (reservation.enterdt && reservation.leavedt) {
    return RESERVATION_STATUS.COMPLETED
  }
  if (reservation.enterdt && !reservation.leavedt) {
    if (moment.unix(reservation.enterdt) < moment().add(-1 * 300, 'minutes'))
    {
      return RESERVATION_STATUS.COMPLETED
    }
    if (moment.unix(reservation.enterdt) < moment().add(-1 * store.minutes_before_out, 'minutes'))
    {
      return RESERVATION_STATUS.AUTOEXIT
    }
    return RESERVATION_STATUS.IN_STORE
  }
  if (reservation.dt > moment.utc(moment.tz(store.timezone).format("YYYY-MM-DDTHH:mm:ss")).add(-1 * store.minutes_before_expire, 'minutes').unix()) {
      return RESERVATION_STATUS.ACTIVE
  }
  return RESERVATION_STATUS.EXPIRED
}


export const PAGE_IDS = {
  BRAND_DASHBOARD:'brand_dashboard',
  BRAND_DASHBOARD_SINGLE_STORE:'brand_dashboard_single_store',
  BRANDS_LIST: 'brands_list',
  BRAND_DETAILS: 'brand_details',
  BRAND_EDIT: 'brand_edit',
  BRAND_ADD: 'brand_add',
  STORES_LIST: 'stores_list',
  STORE_DETAILS: 'store_details',
  STORE_DASHBOARD: 'store_dashboard',
  STORE_ADD: 'store_add',
  STORE_EDIT: 'store_edit',
  SCAN: 'scan',
  SEARCH: 'search',
  FAVORITES: 'favorites',
  RESERVATIONS: 'reservations',
  RESERVATION_DETAIL: 'reservation_detail',
  RESERVATION_ADD: 'reservation_add',
  AUTH: 'auth',
  SIGNOUT: 'signout',
  SIGNIN: 'signin',
  PROFILE: 'profile',
  SWITCH: 'switch',
  PAGE_500: "error500",
  PAGE_404: "error404",
  PAGE_403: "error403",
  HOW_IT_WORKS: "how_it_works",
  CHANGE_PASSWORD: "change_password",
  PRIVACY_PAGE: "privacy_page",
}





// WEBPACK FOOTER //
// ./src/utils/constants.js